<h1 mat-dialog-title>{{"home.orders.infoDialogTitle"| translate}}</h1>
<div mat-dialog-content>
    <p>
        <span>{{"home.orders.deliveryNumber" | translate}}</span>: {{data.item.deliveryNumber}}<br>
        <span>{{"home.orders.deliveryDate" | translate}}</span>: {{i18nService.toDateString(data.item.deliveryDate)}}<br>
        <span>{{"home.orders.orderNumberErp" | translate}}</span>: {{data.item.erpOrderId}}<br>
        <span>{{"home.orders.orderNumberWebshop" | translate}}</span>: {{data.item.externalOrderId}}<br>
        <span>{{"home.orders.desireDate" | translate}}</span>: {{i18nService.toDateString(data.item.desireDate)}}
    </p>
</div>
<div mat-dialog-actions>
    <button mat-flat-button color="primary" (click)="okClick()" class="action-button">OK</button>
</div>